import { useEffect, useState } from "react";
import ReactHlsPlayer from "react-hls-player";
import { useParams } from "react-router-dom";
import { decryptUrl } from "../../../utils/encryption";

const InterviewVideoPlayer = () => {
  const { video_url: encrypted } = useParams();
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [type, setType] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (encrypted) {
      try {
        const decrypted = decryptUrl(decodeURIComponent(encrypted));
        setVideoUrl(decrypted);
        const extension =
          (decrypted.split(".").pop() || "").toLowerCase() || null;
        setType(extension);
      } catch (err) {
        console.error("Failed to decrypt video URL");
        setError("Failed to load video. Please try again.");
      }
    }
  }, [encrypted]);

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-6">
        <div className="bg-red-500/10 border border-red-500/20 rounded-2xl p-8 max-w-md text-center backdrop-blur-sm">
          <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-red-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-red-400 mb-2">
            Error Loading Video
          </h3>
          <p className="text-slate-300">{error}</p>
        </div>
      </div>
    );
  }

  if (!videoUrl) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
        <div className="flex flex-col items-center justify-center animate-pulse">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            viewBox="0 0 24 24"
            className="w-20 h-20 text-slate-600"
          >
            <path d="M17 10.5V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4.5l5 5v-13l-5 5z" />
          </svg>
          <p className="text-gray-600 text-lg mt-4">Loading video...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center">
      <div className="w-full h-full">
        <div className="relative w-full h-screen group">
          <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-none blur-2xl opacity-20 group-hover:opacity-30 transition-opacity duration-500 z-0"></div>

          <div className="relative z-10 w-full h-full bg-slate-800/50 backdrop-blur-sm overflow-hidden border-t border-slate-700/50 shadow-2xl">
            <div className="w-full h-full flex items-center justify-center bg-black">
              {type !== "mp4" ? (
                <ReactHlsPlayer
                  src={videoUrl}
                  autoPlay={false}
                  controls={true}
                  className="w-full h-full object-contain"
                />
              ) : (
                <video
                  src={videoUrl}
                  autoPlay={false}
                  controls={true}
                  className="w-full h-full object-contain"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewVideoPlayer;
